import { useConvexMutation } from '@convex-dev/react-query';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { api } from '~/convex/_generated/api';
import type { Id } from '~/convex/_generated/dataModel';
import type { ReportSection } from '~/convex/lib/types';

interface UseReportSaveOptions {
  reportId: Id<'reports'>;
  onSaved?: () => void;
}

interface SaveArgs {
  generatedSections?: ReportSection[];
  patientName?: string;
}

export function useReportSave({ reportId, onSaved }: UseReportSaveOptions) {
  const { t } = useTranslation();

  const {
    mutate: saveReport,
    isPending: isSaving,
    error,
  } = useMutation({
    mutationFn: useConvexMutation(api.reports.updateReportSections),
    onSuccess: () => {
      onSaved?.();
    },
    onError: () => {
      toast.error(t('errors:errorUpdatingReport'));
    },
  });

  const save = (args: SaveArgs) => {
    saveReport({
      id: reportId,
      generatedSections: args.generatedSections,
      patientName: args.patientName,
      documentStale: true,
    });
  };

  return { save, isSaving, error };
}
